import { Flex, Center, Image, Text } from '@chakra-ui/react';

function SeasonLand({ handleClick, seasons, currentSeason }) {
  return (
    <Flex
      justifyContent="space-between"
      h="484px"
      alignItems="center"
      w="429px"
      flexDirection="column"
      as="button"
      onClick={handleClick}
      cursor="pointer"
    >
      <Center>
        <Image src={seasons[currentSeason].image} w="429px" h="417px" />
      </Center>
      <Text
        bgColor="rgba(10, 16, 30, 1)"
        color="white"
        border="1px solid rgba(255, 246, 228, 1)"
        borderRadius="10px"
        h="40px"
        w="232px"
        textAlign="center"
        lineHeight="40px"
      >
        {seasons[currentSeason].text}
      </Text>
    </Flex>
  );
}

export default SeasonLand
